import type { Nullable } from "../../../../typescript"
import isEntityLayerIdTerrain1 from "../../entity/EntityLayerId/isEntityLayerIdTerrain1"
import type { Entity } from "../../entity/index"
import type { TileGraphNode } from "./TileGraphNode.type"

export default function getTileGraphNodeLayer1Entity(node: Nullable<TileGraphNode>): Nullable<Entity> {
  return node?.ents().find(isEntityLayerIdTerrain1)
}